import React from "react";
import { Link } from "react-router-dom";
import PolicyPage, { H2, LI, P, UL } from "../../components/PolicyPage";

export default function Terms() {
  return (
    <PolicyPage
      slug="terms-of-sale"
      title="Terms of Sale"
      updated="June 2026"
      seoDescription="Terms of sale for NQ Springs & 4x4 Accessories: pricing, GST, stock availability, fitment, payment, title and risk, and governing law."
      intro="These terms apply to every order placed through this website. Placing an order means you accept them."
    >
      <section>
        <H2>Who you are dealing with</H2>
        <P>
          NQ Springs & 4x4 Accessories, 321 Ingham Rd, Garbutt QLD 4814. Phone{" "}
          <a href="tel:0747748859" className="gold-text font-semibold">(07) 4774 8859</a>, email{" "}
          <a href="mailto:info@nqsprings.com.au" className="gold-text font-semibold">info@nqsprings.com.au</a>.
        </P>
      </section>

      <section>
        <H2>Prices and GST</H2>
        <UL>
          <LI>All prices are in Australian dollars and include GST where applicable.</LI>
          <LI>Surplus and clearance items are listed at our cost price. Prices can change at any time; the price shown when you check out is the price you pay.</LI>
          <LI>Freight is additional unless the order qualifies for free standard shipping.</LI>
        </UL>
      </section>

      <section>
        <H2>Stock and availability</H2>
        <UL>
          <LI>Most surplus lines are one-of. Stock counts are updated as orders are paid, but two people can still reach the checkout at the same time.</LI>
          <LI>If an item sells out after you order, we will contact you and refund it in full - we will never substitute a different part without asking.</LI>
          <LI>We may cancel an order where an item is unavailable, a price or description was clearly wrong, or we suspect fraud. Any payment is refunded in full.</LI>
        </UL>
      </section>

      <section>
        <H2>Fitment and suitability</H2>
        <P>
          Descriptions and fitment notes are provided in good faith based on supplier information
          and our own experience. It remains your responsibility to confirm a part suits your
          vehicle, its modifications and its intended use before ordering - see{" "}
          <Link to="/returns-refunds" className="gold-text font-semibold">Returns & Refunds</Link>. Some
          products affect vehicle compliance; suspension lifts, GVM upgrades and similar work must be
          fitted and certified appropriately. Ask us and we will point you the right way.
        </P>
      </section>

      <section>
        <H2>Payment</H2>
        <UL>
          <LI>Card payments are processed by Stripe. We never see or store your full card details.</LI>
          <LI>Your order is only confirmed once payment is received. Until then, stock is not held.</LI>
          <LI>Title in the goods passes to you on full payment; risk passes when the goods are handed to the carrier or collected.</LI>
        </UL>
      </section>

      <section>
        <H2>Warranty and liability</H2>
        <P>
          Surplus stock is sold without warranty beyond the consumer guarantees under the Australian
          Consumer Law. To the extent permitted by law, we are not liable for indirect or
          consequential loss, including loss of use, lost time, towing, or the cost of fitting or
          removing a part. Nothing in these terms limits rights that cannot lawfully be limited.
        </P>
      </section>

      <section>
        <H2>Website content and governing law</H2>
        <UL>
          <LI>Images are indicative. Colours, finishes and included hardware can vary between production runs.</LI>
          <LI>All content on this site belongs to NQ Springs & 4x4 Accessories or its suppliers and may not be reused without permission.</LI>
          <LI>These terms are governed by the laws of Queensland, Australia.</LI>
        </UL>
      </section>
    </PolicyPage>
  );
}
